

import { useNavigate } from "react-router-dom";
import { IconButton, Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { AlertScreen } from "../../components/AlertScreen";
import { envVariables } from "../../../../helpers";
import { useLotesStore } from "../../../../store";
import { useLotesFuncion } from "../../../../hooks";
import dayjs from "dayjs";



const paginado = Number( envVariables.REACT_APP_PAGINADO);



export const TablaListadoLotes = ({ data, chagePage=null, page=0 }) => {

    const navigate = useNavigate();
    const { totalLote } = useLotesStore();
    const { handleTrueFalse } = useLotesFuncion();
    


    const handleOpcionesLote = (id) => {
        navigate(`/admin/opcion/${id}/lote`)
    }



    return (
        <>
        {(data.length > 0) 
        ?   <Paper sx={{ width: '100%', maxWidth: {xs:450, sm:800, md:'100%'}, overflowX: 'auto', mt:2 }}>
                <TableContainer sx={{ maxWidth:'100%' }}>
                    <Table sx={{ minWidth: 700 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{width:'5%'}}>A.</TableCell>
                                <TableCell sx={{width:'17%'}}>LOTE</TableCell>
                                <TableCell sx={{width:'18%'}}>ENCUBADORA</TableCell>
                                <TableCell sx={{width:'15%'}}>TOTAL</TableCell>
                                <TableCell sx={{width:'15%'}}>MACHOS</TableCell>
                                <TableCell sx={{width:'15%'}}>HEMBRAS</TableCell>
                                <TableCell sx={{width:'15%'}}>F. INICIO</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {data.map((lote) => (
                            <TableRow key={ lote.id } onClick={() => handleOpcionesLote(lote.id)} sx={{cursor:'pointer'}}>
                                <TableCell>
                                    {(lote.activo)
                                    ?   <IconButton className='boton-estado trru'
                                            onClick={ (e) => handleTrueFalse(e, lote) }
                                        />
                                    :   <IconButton className='boton-estado fall'
                                            onClick={ (e) => handleTrueFalse(e, lote) }
                                        />
                                    }
                                </TableCell>
                                <TableCell> { lote.lote } </TableCell>
                                <TableCell> { lote.encubadora?.nombre } </TableCell>
                                <TableCell> { lote.cantidadTotal } </TableCell>
                                <TableCell> { lote.machos } </TableCell>
                                <TableCell> { lote.hembras } </TableCell>
                                <TableCell>{dayjs(lote.createdAt).format('DD/MMM/YY HH:mm').toUpperCase()}</TableCell>
                            </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(totalLote / paginado)} disabled={Math.ceil(totalLote / paginado) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
                </TableContainer>
            </Paper>

        :   <AlertScreen title="No hay lotes creados por el momento..."/>
        }
        </>
    )
}
